import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ThemeContext, useThemeStorage } from './hooks/useTheme';
import { useClarityTracking } from './hooks/useClarityTracking';
import { GOOGLE_OAUTH_CONFIG } from './config/oauth';
import AppRoutes from './routes';

// Theme Provider Wrapper Component
const ThemeProviderWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const themeData = useThemeStorage();

  return (
    <ThemeContext.Provider value={themeData}>
      <MuiThemeProvider theme={themeData.theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};

// Analytics Wrapper Component
const AnalyticsWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Initialize Clarity tracking (user identification, page views)
  useClarityTracking();

  return <>{children}</>;
};

const App: React.FC = () => {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_OAUTH_CONFIG.clientId}>
      <BrowserRouter>
        <ThemeProviderWrapper>
          <AnalyticsWrapper>
            <AppRoutes />
          </AnalyticsWrapper>
        </ThemeProviderWrapper>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
};

export default App;